import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Loader } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TermsPage() {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/terms`)
      .then(r => setContent(r.data.content))
      .catch(() => setContent("No se pudieron cargar los términos."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#F5EEDB] px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <Link to="/register" className="flex items-center gap-2 text-[#5B3E2E]/60 hover:text-[#5B3E2E] mb-6">
          <ArrowLeft size={18} />
          <span className="text-sm">Volver al registro</span>
        </Link>
        <h1 className="font-heading text-2xl text-[#5B3E2E] mb-6 font-bold" data-testid="terms-title">
          Términos y Condiciones
        </h1>
        {loading ? (
          <Loader size={24} className="text-[#E48D57] animate-spin mx-auto" />
        ) : (
          <div data-testid="terms-content" className="bg-[#FDFAF4] rounded-3xl border border-[#5B3E2E]/10 p-6 sm:p-8">
            <pre className="whitespace-pre-wrap font-['Manrope'] text-sm text-[#5B3E2E]/80 leading-relaxed">
              {content}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
}
